function rowHeights() {
  console.log('csoki')
  const sections = document.querySelectorAll('.comparsion_section')
  if (sections) {
    Array.prototype.forEach.call(sections, (sect) => {
      const cols = sect.querySelectorAll('.column-wrapper')
      if (cols) {
        const colTitleRows = sect.querySelectorAll('.row-title')
        const colonerows = cols[1].querySelectorAll('.row-main-wrapper')
        const coltworows = cols[2].querySelectorAll('.row-main-wrapper')
        if (colonerows && colonerows) {
          const mediaWidth = '(min-width:992px)'
          Array.prototype.forEach.call(colonerows, (colonerow, i) => { 
            const colOneRowHeight = colonerow.getBoundingClientRect().height
            const colTwoRowHeight = coltworows[i].getBoundingClientRect().height
            if (window.matchMedia(mediaWidth).matches) {
              if (colOneRowHeight < colTwoRowHeight) {
                colonerow.style.minHeight = `${colTwoRowHeight}px`
                colTitleRows[i].style.minHeight = `${colTwoRowHeight - 50}px`
              } else {
                coltworows[i].style.minHeight = `${colOneRowHeight}px`
                colTitleRows[i].style.minHeight = `${colOneRowHeight - 50}px`
              }
            } else {
              colonerow.style.minHeight = `unset`
              coltworows[i].style.minHeight = `unset`
              colTitleRows[i].style.minHeight = `unset`
            }
          })
        }
      }
    })
  }
}
document.addEventListener('DOMContentLoaded', () => {
  rowHeights()
  setTimeout(() => {
    rowHeights()
  }, 200)
})
window.addEventListener('resize', () => {
  console.log('csoki')
  rowHeights()
})
